import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { KYMW9004Component } from "./kymw9004.component";

export class KYMW9004Model {
  kymw9004Component: KYMW9004Component;

  /** 権限セットID */
  public authoritySetId: string = <string>'';
  /** 権限セット名 */
	public authoritySetName: string = <string>'';
	/** 管理者区分(0:非管理者、1:管理者) */
	public adminDiv: string = <string>'';
  public check_AdminDiv: boolean = <boolean>false;
	/** 権限ステータス(0:有効、1:無効) */
	public authorityStatus: string = <string>'0';
  /** 説明 */
  public authoritySetExplanation: string = <string>'';
  /** 機能リスト */
  public funcAuthorityList: Array<any> = new Array<any>();

  /**
   * 機能一覧取得のレスポンスデータを取得
   * @param serverData
   */
  public updateAuthoritySetList(serverData): void {
    this.funcAuthorityList = serverData.FuncInfoList;
    
    if ( !PlessViewUtilsSub.isEmptyArray(this.funcAuthorityList) ) {
      // 新規登録時は権限を使用不可にする
      this.funcAuthorityList.forEach(item => item.EnableMode = '0');
    }
  }

  /**
   * ユーザ権限情報取得のレスポンスデータを取得（更新時）
   * @param serverData
   */
  public updateAuthoritySetDetail(serverData): void {
    this.authoritySetId = serverData.AuthoritySetId;
    
    this.authoritySetName = serverData.AuthoritySetName;
    // 管理者区分(0:非管理者、1:管理者)
    if (serverData.AdminDiv === '1') {
      this.check_AdminDiv = true;
    } else {
      this.check_AdminDiv = false;
    }
    this.authorityStatus = serverData.AuthorityStatus;

    this.authoritySetExplanation = serverData.AuthoritySetExplanation;

    this.funcAuthorityList = serverData.FuncInfoList;
    if ( PlessViewUtilsSub.isEmptyArray(this.funcAuthorityList) ) {
      this.kymw9004Component.dialogService.openAlert('システムエラーが発生しました', 'S');
    }
  }
}